import type { IconComponent } from '@components/icons/types'

/** Google logo */
export const Google: IconComponent = ({
    className,
    width,
    height,
    ...restOfProps
}) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 18 19'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
        {...restOfProps}
    >
        <path
            d='M17.64 9.27792C17.64 8.63974 17.5827 8.0261 17.4764 7.43701H9V10.9184H13.8436C13.635 12.0434 13.0009 12.9966 12.0477 13.6347V15.8929H14.9564C16.6582 14.3261 17.64 12.0188 17.64 9.27792Z'
            fill='#4285F4'
        />
        <path
            d='M9 18.0732C11.43 18.0732 13.4673 17.2673 14.9564 15.8927L12.0477 13.6346C11.2418 14.1746 10.2109 14.4937 9 14.4937C6.65591 14.4937 4.67182 12.9105 3.96409 10.7832H0.957275V13.115C2.43818 16.0564 5.48182 18.0732 9 18.0732Z'
            fill='#34A853'
        />
        <path
            d='M3.96409 10.7831C3.78409 10.2431 3.68182 9.66625 3.68182 9.07307C3.68182 8.47989 3.78409 7.90307 3.96409 7.36307V5.03125H0.957273C0.347727 6.24625 0 7.6208 0 9.07307C0 10.5253 0.347727 11.8999 0.957273 13.1149L3.96409 10.7831Z'
            fill='#FBBC05'
        />
        <path
            d='M9 3.65279C10.3214 3.65279 11.5077 4.10688 12.4405 4.9987L15.0218 2.41733C13.4632 0.96506 11.4259 0.0732422 9 0.0732422C5.48182 0.0732422 2.43818 2.09006 0.957275 5.03142L3.96409 7.36324C4.67182 5.23597 6.65591 3.65279 9 3.65279Z'
            fill='#EA4335'
        />
    </svg>
)
